<template>
  <m-demo-box demo-option="suppression">
    <b-row class="demo-box" :align-h="mobileCSS">
      <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
        <div class="item">
          <b-checkbox :checked="type.order != false" @change="changeType('order', $event)" data-test="demo-suppress-order">
            Suppress Prior Order(s)
          </b-checkbox>
          <m-suppression-item v-show="type.order"
                              suppressionType="order"
                              :subType="type.order"
                              item-title="By Selected Order(s)"
                              class="suppression-item"
                              @updateType="changeSubType('order', $event)"/>

        </div>
        <div class="item">
          <b-checkbox :checked="type.slc != false" @change="changeType('slc', $event)"  data-test="demo-suppress-slc">
            Suppress Saved List Count(s)
          </b-checkbox>
          <m-suppression-item v-show="type.slc"
                              suppressionType="slc"
                              :subType="type.slc"
                              item-title="By Selected Saved Count(s)"
                              class="suppression-item"
                              @updateType="changeSubType('slc', $event)"/>

        </div>
        <div class="item" v-if="listType === 10">
          <b-checkbox :checked="type.file != false" @change="changeType('file', $event)"  data-test="demo-suppress-file">
            Suppress Uploaded File
          </b-checkbox>
          <div v-show="type.file" suppressionType="file">
            <m-suppression-item v-show="type.file"
                                suppressionType="file"
                                :subType="type.file"
                                class="suppression-item"
                                @updateType="changeSubType('file', $event)"/>

            <m-upload-suppression style="margin-top: 8px"></m-upload-suppression>
            <p class="ml-2 mt-1">
              You have the option to upload a file so that when you order new leads, you may automatically exclude those that appear in the file.<br/>
              <b-link :href="$store.getters['config/link']('DownsuppressionTempFile')">Download suppression template file</b-link>
            </p>
          </div>
        </div>
      </b-col>
    </b-row>
  </m-demo-box>
</template>

<script>
  import MDemoBox from '@/components/demo/MDemoBox'
  import MSuppressionItem from '@/components/demo/MsuppressionItem'
  import MUploadSuppression from '@/components/demo/MUploadsuppression'
  import _ from 'lodash'

  export default {
    components: {
      MDemoBox,
      MSuppressionItem,
      MUploadSuppression
    },
    data () {
      return {
        file: null
      }
    },
    computed: {
      type () {
        return this.$store.getters['order/suppressionType']
      },
      listType () {
        return this.$store.state.order.ListType
      },
      mobileCSS () {
        return this.$store.state.config.isMobile?"center":"start"
      }
    },
    created () {
      if (this.$store.state.order.SuppressionType === 0) {
        this.$store.dispatch('order/updateSuppressionType', {
          order: false,
          slc: false,
          file: false
        })
      }
    },
    methods: {
      changeSubType (key, val) {
        let type = Object.assign({}, this.type)
        type[key] = val
        if (!_.isEqual(this.type, type)) {
          this.$store.dispatch('order/updateSuppressionType', type)
        }
      },
      changeType (key, val) {
        if (val === true) {
          val = 'date'
        }
        let type = Object.assign({}, this.type)
        type[key] = val
        if (!_.isEqual(this.type, type)) {
          this.$store.dispatch('order/updateSuppressionType', type)
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .suppression-item {
    /*margin-bottom: 16px;*/
  }

  .item {
    padding: 16px 0;
    border-bottom: 1px solid $color-border;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/DemoSuppression.vue